import React, { PureComponent } from 'react';
import { Row, Col, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { arrayOf, number, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { STATIC_PATH } from '../../config';
import { FMessage } from '../../hoc/IntlComponents';
import { getStoreUrl } from '../../utils/utils';

class OfferCardInfo extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    url: string,
    pic: string,
    categories: arrayOf(number),
  };

  state = {
    popoverOpen: false,
    coinsTooltipOpen: false,
  };

  // renderCoinTooltip = ({ id, target, coins }) => {
  //   return (
  //     <UncontrolledPopover
  //       trigger="hover"
  //       className="offer-coins-popover"
  //       placement="left"
  //       target={`${target}-${id}`}
  //     >
  //       <PopoverHeader>
  //         {' '}
  //         <b>
  //           <FMessage id="offer.tooltip.header" />
  //         </b>
  //       </PopoverHeader>
  //       <PopoverBody>
  //         {' '}
  //         <div>
  //           <FormattedMessage
  //             id="offer.tooltip.p"
  //             defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
  //             values={{
  //               coins,
  //             }}
  //           />
  //           <a href={getStoreUrl()} target="_blank">
  //             <FMessage id="offer.tooltip.link-to-store" />
  //           </a>
  //         </div>
  //       </PopoverBody>
  //     </UncontrolledPopover>
  //   );
  // };

  // renderCoins = () => {
  //   const {
  //     modifies: { coins },
  //     id,
  //   } = this.props;
  //   if (coins === 1) {
  //     return (
  //       <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
  //         <img src={`${STATIC_PATH}/img/coin-big.svg`} />
  //         {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
  //       </div>
  //     );
  //   } else if (coins === 2) {
  //     return (
  //       <Link to="/offers/double" id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
  //         <img src={`${STATIC_PATH}/img/coin-big.svg`} />
  //         <img src={`${STATIC_PATH}/img/coin-big.svg`} />
  //         {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
  //       </Link>
  //     );
  //   }
  //   return null;
  // };

  render() {
    const {
      title,
      url,
      pic,
      children,
      modifies: { exclusive },
      admit,
      categories,
    } = this.props;

    return (
      <div className="offer-main-info">
        <div>
          <div className="offer-main-info-wrapper">
            <h3 className="offer-main-info-title">{title}</h3>
            <div className="offer-main-info-badges">
              {exclusive && <span className="badge badge-danger">exclusive</span>}
              {admit.private && <span className="badge badge-private">private</span>}
              {Array.isArray(categories) && categories.includes(100) && (
                <span className="badge badge-tiktok">TikTok</span>
              )}
            </div>
            {url && (
              <a href={url} className="offer-link offer-link-mob" target="_blank">
                {url}
              </a>
            )}
          </div>
          {url && (
            <a href={url} className="offer-link offer-link-desk" target="_blank">
              {url}
            </a>
          )}
        </div>
        <div className="badges-wrapper">{children}</div>
        {/* {this.renderCoins()} */}
      </div>
    );
  }
}

export default OfferCardInfo;
